import { type ComponentProps } from 'react'
import { GripHorizontal } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

interface SidepanelSectionDragHandleProps extends ComponentProps<'span'> {}

/**
 * Centered grip that appears with the header's hover pill. This is the section's
 * only reorder surface.
 */
export function SidepanelSectionDragHandle({ className, ...props }: SidepanelSectionDragHandleProps) {
  return (
    <span
      aria-hidden="true"
      data-section-drag-handle
      className={twMerge(
        // Keep pointer-events on while hidden so touch (no hover) can still
        // start a reorder; only opacity is hover-gated. Sits in flow after the
        // header lead so a wide title (badge, chevron) pushes it right of center
        // instead of overlapping — `size-5` is half of the lead's `50% - 0.625rem`.
        'text-foreground-placeholder flex size-5 shrink-0 touch-none select-none items-center justify-center',
        'opacity-0',
        'group-hover/section-header:opacity-100',
        className,
      )}
      {...props}
    >
      <GripHorizontal strokeWidth={2} className="size-3.5" />
    </span>
  )
}
